module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_point-12a5a2ea98df22f671acf5838431a1c3.svg";